var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import PlusIcon from 'components/Icons/PlusIcon';
import Button from 'components/Button/Button';
import ExternalLink from 'components/Icons/ExternalLink';
import styleConstants from 'app/assets/styles/style-constants';
import globalConstants from 'app/constants/global-constants';
import Render from 'components/Render';
import { getLaunchUrl } from '../SandboxList/helper';
import { beginCreateSandbox } from '../../actions/sandboxActions';
import { showModal } from '../../actions/modalActions';
import { sandboxUseCasesFlat } from '../../constants/usecaseContants';
var getSandboxDisplayName = function (sandboxName) {
    if (!sandboxName)
        return null;
    var sandboxDisplayName = sandboxName &&
        sandboxUseCasesFlat.find(function (item) { return item.name === sandboxName; });
    if (sandboxDisplayName)
        return sandboxDisplayName.long_name;
    return null;
};
var SingleUseCase = /** @class */ (function (_super) {
    __extends(SingleUseCase, _super);
    function SingleUseCase(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSandboxCreate = _this.handleSandboxCreate.bind(_this);
        _this.handlePostLaunch = _this.handlePostLaunch.bind(_this);
        return _this;
    }
    SingleUseCase.prototype.handleSandboxCreate = function () {
        var _a = this.props, usecase = _a.usecase, handleBeginCreateSandbox = _a.handleBeginCreateSandbox, user = _a.user;
        handleBeginCreateSandbox({
            usecase: usecase.name,
            isDraft: false
        });
    };
    SingleUseCase.prototype.handlePostLaunch = function () {
        var _a = this.props, usecase = _a.usecase, onClose = _a.onClose;
        window.neo4jSandbox.tracking.event('SANDBOX_LAUNCH', {
            usecase: usecase,
        });
        onClose();
    };
    SingleUseCase.prototype.render = function () {
        var _a = this.props, desiredUseCase = _a.usecase, isCreating = _a.isCreating, items = _a.items, open = _a.open, onClose = _a.onClose, user = _a.user, showCreateModal = _a.showCreateModal;
        if (!desiredUseCase)
            return null;
        var matchedRunningSandbox = items.find(function (i) { return i.usecase === desiredUseCase.name; });
        var isUsecaseActive = matchedRunningSandbox && !!matchedRunningSandbox.ip;
        var sandboxDisplayName = desiredUseCase && getSandboxDisplayName(desiredUseCase.name);
        var launchUrl = isUsecaseActive && getLaunchUrl(matchedRunningSandbox, user.accessToken);
        return (React.createElement(Modal, { centered: true, open: open, size: "tiny", onClose: onClose, closeIcon: true },
            React.createElement(Modal.Header, { className: "text-center", style: { borderBottom: 'none' } },
                sandboxDisplayName || desiredUseCase.long_name,
                ' ',
                (sandboxDisplayName || desiredUseCase.long_name)
                    .toLowerCase()
                    .indexOf('blank') === -1
                    ? 'Dataset'
                    : ''),
            React.createElement(Modal.Content, { className: "text-center" },
                React.createElement(Render, { if: !isUsecaseActive },
                    React.createElement(Button, { color: "blue", icon: !isCreating && (React.createElement(PlusIcon, { size: 16, color: styleConstants.colors.white })), loading: isCreating, size: "small", iconBefore: true, onClick: this.handleSandboxCreate, labeled: true }, globalConstants.dictionary.launchProject)),
                React.createElement(Render, { if: isUsecaseActive === true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "font-small font-italic color-primary" }, "You already have the dataset running."),
                        React.createElement("a", { href: launchUrl, target: "_blank", rel: "noreferrer" },
                            React.createElement(Button, { primary: true, size: "small", icon: React.createElement(ExternalLink, null), onClick: this.handlePostLaunch, className: "font-regular", labeled: true }, "Open Neo4j Browser")))),
                React.createElement("p", { className: "mt2 font-x-small" },
                    React.createElement("button", { type: "button", className: "uncolored-link-w-underline", onClick: showCreateModal }, "or select a new dataset")))));
    };
    return SingleUseCase;
}(Component));
var mapStateToProps = function (state) { return ({
    user: state.user,
    isCreating: state.sandbox.isCreating,
    items: state.sandbox.items,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    handleBeginCreateSandbox: function (params) {
        return dispatch(beginCreateSandbox(params));
    },
    showCreateModal: function () { return dispatch(showModal({ type: 'create' })); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SingleUseCase);
